import { render } from "./SpecialContainer.vue?vue&type=template&id=8182d898&scoped=true"
import script from "./SpecialContainer.vue?vue&type=script&lang=js"
export * from "./SpecialContainer.vue?vue&type=script&lang=js"

import "./SpecialContainer.vue?vue&type=style&index=0&id=8182d898&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8182d898"]])

export default __exports__